import React from 'react'
import {
  PlanDetailsStyled,
  ActionWrapper,
} from 'Features/accountSettings/components/PlanDetails/PlanDetails.styled'
import { CurrentPlanDetails } from '../CurrentPlanDetails/CurrentPlanDetails'
import { CancelPlan } from '../CancelPlan/CancelPlan'
import { CancelProduct } from '../CancelProduct/CancelProduct'
import { DataUsage } from 'Features/accountSettings/components/DataUsage/DataUsage'
import { useMigrationDisplay } from 'Hooks/useMigrationDisplay'
import { useIsCancelProductFlow } from 'Features/accountSettings/hooks/useIsCancelProductFlow'

export const PlanDetails = () => {
  const { isMigratedAccount, isMigrationFinished } = useMigrationDisplay()
  const { isCancelProductFlowAllowed } = useIsCancelProductFlow()
  const showCancelPlan = isMigratedAccount ? isMigrationFinished : true

  return (
    <PlanDetailsStyled id={'account-settings-plan-details-tab'}>
      <CurrentPlanDetails />
      <ActionWrapper>
        <DataUsage />
        {isCancelProductFlowAllowed && <CancelProduct />}
        {showCancelPlan && <CancelPlan />}
      </ActionWrapper>
    </PlanDetailsStyled>
  )
}
